import { render } from "./ProjectCreation.vue?vue&type=template&id=dcbd4a3c&scoped=true"
import script from "./ProjectCreation.vue?vue&type=script&lang=js"
export * from "./ProjectCreation.vue?vue&type=script&lang=js"

import "./ProjectCreation.vue?vue&type=style&index=0&id=dcbd4a3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcbd4a3c"]])

export default __exports__